import React, {ReactNode} from 'react';
import {FlexRow, Icon, Text, Tooltip} from '@forecast-it/design-system';
import {FormattedMessage} from 'react-intl';

export const ContentWarning = ({
	children,
	showWarning,
	hasRemaining,
}: {
	children: ReactNode;
	showWarning: boolean;
	hasRemaining: boolean;
}): JSX.Element => {
	let warningId: string | undefined;
	if (showWarning) {
		warningId = hasRemaining ? 'scheduling.utilization.warning.demand' : 'scheduling.utilization.warning.time_entries';
	}
	return showWarning ? (
		<Tooltip
			interactable={false}
			content={
				<Text>
					<FormattedMessage id={warningId} />
				</Text>
			}
		>
			<FlexRow gap={'xs'}>
				<Icon icon={'alert'} size={'s'} color={'error'} />
				<Text color={'error'}>{children}</Text>
			</FlexRow>
		</Tooltip>
	) : (
		<Text>{children}</Text>
	);
};
